// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".price-62ce7 {\n  position: relative;\n  display: inline-block;\n  white-space: nowrap;\n  width: auto;\n  font-size: 3.3816425120773vw;\n  font-family: DIN;\n}\n.price-62ce7 .prefix-626e8 {\n  position: relative;\n  display: inline-block;\n  font-size: 2.8985507246377vw;\n  font-weight: 600;\n}\n.price-62ce7 .number-35b9e {\n  display: inline-block;\n  position: relative;\n}\n.price-62ce7 .line-04785 {\n  position: absolute;\n  top: 50%;\n  right: -5%;\n  left: 0%;\n  height: 1px;\n}\n", ""]);
// Exports
exports.locals = {
	"price": "price-62ce7",
	"prefix": "prefix-626e8",
	"number": "number-35b9e",
	"line": "line-04785"
};
module.exports = exports;
